import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../assets/DamImage.png";
import pic2 from "../../assets/Bridges.png";

const FifthSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);
  return (
    <div className="bg-gray-100 py-10 px-5 md:px-10 lg:px-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
          data-aos="fade-right"
        >
          <img
            src={pic1}
            alt="Sluice Gates"
            className="w-full h-64 md:h-80 object-cover"
            data-aos="zoom-in"
          />
          <div className="p-6 flex-grow">
            <p
              className="text-gray-700 text-md md:text-lg leading-relaxed  heebo text-justify"
              data-aos="fade-up"
            >
              Sailesh Dani, a trailblazer in mechanical manufacturing,
              introduced sandblasting with epoxy treatment for the first time in
              Odisha’s mega spillway sluice gates. With an unwavering{" "}
              <span className="font-bold">15-year service</span> to the Hirakud
              Dam, he revolutionized maintenance techniques and enhanced
              durability.
            </p>
          </div>
        </div>

        <div
          className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
          data-aos="fade-left"
          data-aos-delay="100"
        >
          <img
            src={pic2}
            alt="Gantry Crane Disc Plates"
            className="w-full h-64 md:h-80 object-cover"
            data-aos="zoom-in"
          />
          <div className="p-6 flex-grow">
            <p
              className="text-gray-700 text-md md:text-lg leading-relaxed text-justify heebo"
              data-aos="fade-up"
            >
              He also pioneered the manufacturing of 100-ton gantry crane disc
              plates through his innovative processes, showcasing his
              engineering expertise. As a visionary, Sailesh Dani is now working
              towards introducing automated systems for spillway sluice gates,
              setting new benchmarks in dam infrastructure.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FifthSection;
